import { render, staticRenderFns } from "./country-column.vue?vue&type=template&id=bbd67752"
import script from "./country-column.vue?vue&type=script&lang=js"
export * from "./country-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports